// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7928":"61811f5a","9704":"4a3a208f"}[chunkId] + ".chunk.css";
};